// extracted by mini-css-extract-plugin
module.exports = {"alert":"SeksjonForKontaktinformasjonAlert_alert__NqSpv","white":"SeksjonForKontaktinformasjonAlert_white__vG5eF","yellow":"SeksjonForKontaktinformasjonAlert_yellow__0cBpA"};